import { useMutation, useQueryClient } from '@tanstack/react-query';

import { protocolosApi } from '../api';
import type { Protocolo } from '../types';
import { protocolosKeys } from './useProtocolos';

export function useActualizarInterpretacion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      uidProtocolo,
      interpretacion_resultados,
    }: {
      uidProtocolo: string;
      interpretacion_resultados: string | null;
    }) => protocolosApi.actualizarInterpretacion(uidProtocolo, { interpretacion_resultados }),
    onSuccess: (updated: Protocolo) => {
      queryClient.setQueryData(protocolosKeys.detail(updated.uid_protocolo), updated);
      void queryClient.invalidateQueries({ queryKey: protocolosKeys.all });
    },
  });
}
